export const PESO = '₱';
